import { useState } from 'react';

import axios from 'axios';
import Loader from './helpers/Loader';
// 3.0.1

const VLESS_CREATE_KEY_URL = 'https://sasovo.cdn-yandex.net/v2-api/vless/createKey';

export default function ServerCreationOverlayVless({ close, getList }) {
	const [newKey, setNewKey] = useState('');
	const [newPlan, setPlan] = useState(0);

	const [url, setURL] = useState('');
	const [xuiVersion, setXuiVersion] = useState('2.6.2');

	const [keyURL, setKeyURL] = useState('');
	const [login, setLogin] = useState('');
	const [password, setPassword] = useState('');
	const [authKey, setAuthKey] = useState('');


	const [isSecondInboundEnabled, setSecondInboundEnabled] = useState(false);

	const [inboundId, setInboundId] = useState('1');
	const [inboundIdTwo, setInboundIdTwo] = useState('-1');

	const [flow, setFlow] = useState('xtls-rprx-vision');
	const [flowTwo, setFlowTwo] = useState('xtls-rprx-vision');

	const [isLoading, setLoading] = useState(false);


	const [isURLEnabled, setURLEnabled] = useState(false);
	const [urlAddress, setURLAddress] = useState("");


	const [port, setPort] = useState('');
	const [portTwo, setPortTwo] = useState('');

	
	const createKey = async () => {
		setLoading(true);
		// login, password, inbound_id, plan
		const data = {
			url: url,
			key_url: keyURL,
			login: login,
			password: password,
			inbound_id: inboundId,
			plan: newPlan,
			xui_version: xuiVersion,
			flow: flow,
			is_second_inbound_enabled: isSecondInboundEnabled,
			flow_two: flowTwo,
			inbound_id_two: inboundIdTwo,
			port: port,
			port_two: portTwo,

			url_enabled: isURLEnabled,
			url_address: urlAddress,
			api_key: authKey,
		};

		if (data.xui_version === '3.0.1') {
			if (authKey.trim().length === 0) {
				alert("Fill API Key");
				setLoading(false);
				return;
			}
		}
		const token = localStorage.getItem('simple_vpn_token');
		if (token === null || token === undefined) {
			alert('Токен не найден');
			setLoading(false);
			return;
		}
		const request = await axios.post(VLESS_CREATE_KEY_URL, data, { headers: { Authorization: `Bearer ${token}` } });
		if (request.data.ok === true) {
			if (request.data.success === false) {
				alert('Something wrong with credentials or Vless server setup...');
				setLoading(false);
				return;
			}
			getList();
			setLoading(false);
			close();
		}
	};

	const validateKey = (string = '') => {
		const cleanedString = string.trim();
		setNewKey(cleanedString);
	};

	const handleClose = (event) => {
		const { id } = event.target;
		if (id === 'overlay') {
			close();
		}
	};

	return (
		<div className='overlay' id='overlay' onClick={handleClose}>
			<div className='overlay-content overlay-content-server wrapped'>
				<div>Добавить сервер</div>
				<input
					className='t-input'
					placeholder='URL админки с портом без последнего /'
					type='text'
					value={url}
					onChange={(e) => setURL(e.target.value.trim())}
				></input>
				<input
					className='t-input'
					placeholder='URL ключей с портом без последнего /'
					type='text'
					value={keyURL}
					onChange={(e) => setKeyURL(e.target.value.trim())}
				></input>
				{xuiVersion !== '3.0.1' ? <>
					<input className='t-input' placeholder='Login' type='text' value={login} onChange={(e) => setLogin(e.target.value.trim())}></input>
					<input
						className='t-input'
						placeholder='Password'
						type='text'
						value={password}
						onChange={(e) => setPassword(e.target.value.trim())}
					></input>
				</> : <>
					<input
						className='t-input'
						placeholder='API Key'
						type='text'
						value={authKey}
						onChange={(e) => setAuthKey(e.target.value.trim())}
					></input>
				</>}

				<div className='t-data-triple'>
					<input
						className='t-input'
						placeholder='InboundID'
						type='text'
						value={inboundId}
						onChange={(e) => setInboundId(e.target.value.trim())}
					></input>
					<select
						className='t-input'
						placeholder='Flow'
						value={flow}
						onChange={(e) => setFlow(e.target.value)}
					>
						<option value={"xtls-rprx-vision"}>xtls-rprx-vision</option>
						<option value={""}>Empty</option>
					</select>
					<input
						className='t-input'
						placeholder='Conf Port'
						type='text'
						value={port}
						onChange={(e) => setPort(e.target.value.trim())}
					></input>
				</div>
				<div className='server-label'>
					<span>URL</span>
					<div>
						<input
							type='checkbox'
							id='trial-select'
							checked={isURLEnabled}
							value={isURLEnabled}
							onChange={() => setURLEnabled(!isURLEnabled)}
							name='trial-select'
							label='URL Enabled'
						></input>
						<label className='t-checkbox-label'>URL Enabled</label>
					</div>
					{isURLEnabled && (
						<>
							<input
								type='text'
								className='t-input'
								value={urlAddress}
								placeholder='https://address.domain'
								onChange={(e) => setURLAddress(e.target.value)}
							/>
						</>
					)}
				</div>
				<select
					className='t-input'
					placeholder='API Version'
					value={xuiVersion}
					onChange={(e) => setXuiVersion(e.target.value)}
				>
					<option value={"2.6.2"}>2.6.2 (stable)</option>
					<option value={"3.0.1"}>3.0.1</option>
				</select>

				{/* </div> */}

				<select className='t-input' type='text' value={newPlan} onChange={(e) => setPlan(e.target.value)}>
					<option value={0}>Base</option>
					<option value={1}>Premium</option>
					<option value={2}>Deeplink</option>
					<option value={3}>Family</option>
					<option value={15}>Family 1y</option>
					<option value={4}>1 Month / UK 🇬🇧</option>
					<option value={5}>1 Month / Finland 🇫🇮</option>
					<option value={6}>1 Month / Germany 🇩🇪</option>
					<option value={10}>1 Month / USA 🇺🇸</option>
					<option value={12}>1 Month / Rus 🇷🇺</option>
					{/* <option value={7}>1 Month / Yota, Tele2</option> */}
					<option value={8}>6 Month / 🇬🇧 UK</option>
					<option value={9}>6 Month / 🇫🇮 Finland</option>
					<option value={13}>6 Month / 🇩🇪 Germany</option>
					<option value={14}>6 Month / 🇺🇸 USA</option>
					{/* <option value={11}>6 Month / Yota, Tele2</option> */}
					<option value={20}>1 Month / Я в Китае 🇨🇳</option>
					<option value={21}>6 Month / Я в Китае 🇨🇳</option>
					<option value={30}>Бизнес</option>
					<option value={99}>Trial (.99)</option>
				</select>
				<button onClick={createKey} className='t-button t-primary'>
					{isLoading ? <Loader /> : 'Добавить'}
				</button>
			</div>
		</div>
	);
}
